module.exports = function () {
  return new Worker(__webpack_public_path__ + "a91ae2b8f356c407e761.worker.js");
};